<template>
    <v-container>
        <Header
            :registryStatus="getBusinessDocumentStatuses"
            :recordIndex="getBusinessDocumentDetails.index"
            :registryTitle="getBusinessDocumentRegistry.name"
            :registryUrl="'business-document'"
            :actualStatus="getBusinessDocumentDetails.status"
            :avatarData="getBusinessDocumentDetails.createdBy"
            @status-changed="changeStatus"
        ></Header>
        <Main :items="items" class="p-relative">
            <v-tab-item
                v-for="item in items"
                :key="item.id"
                slot="tabItems"
                :id="item.id"
            >
                <component :is="item.component"></component>
            </v-tab-item>
            <div slot="information">
                <Information />
                <Modal
                    :title="$t('business-document:edition')"
                    :open="open"
                    :height="'640'"
                    v-on:close="closeModal()"
                >
                    <AEContent slot="AEContent" />
                    <Buttons
                        @closeModal="open = false"
                        :action="'edit'"
                        slot="buttons"
                    />
                </Modal>
                <div class="d-flex justify-end buttons--details">
                    <v-tooltip left>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                fab
                                dark
                                v-on="on"
                                v-if="edit()"
                                small
                                @click="editBusinessDocument()"
                                class="buttons--add margin--1"
                            >
                                <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('business-document:edit') }}</span>
                    </v-tooltip>
                </div>
            </div>
        </Main>
    </v-container>
</template>

<script>
import store from './../../../store/index'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Information from '../../../components/Registries/Business-document/Details/Information.vue'
import AEContent from './../../../components/Registries/Business-document/Modal/Content'
import Buttons from './../../../components/Registries/Business-document/Modal/Buttons'

export default {
    i18nOptions: { namespaces: ['global'] },
    components: {
        Information,
        AEContent,
        Buttons,
    },
    data() {
        return {
            open: false,
            items: [],
        }
    },
    computed: {
        ...mapGetters([
            'getBusinessDocumentStatuses',
            'getBusinessDocumentRegistry',
            'getBusinessDocumentDetails',
        ]),
    },
    methods: {
        ...mapMutations([
            'setBusinessDocumentDetails',
            'setBusinessDocumentStatuses',
            'setBusinessDocumentRegistry',
            'setBusinessDocumentModal',
            'clearBusinessDocumentErrors',
            'clearRepresentativesInput',
            'clearBusinessDocumentModal'
        ]),
        ...mapActions(['fetchBusinessDocument', 'updateBusinessDocumentStatus']),
        changeStatus(status) {
            this.updateBusinessDocumentStatus({ status, id: this.getBusinessDocumentDetails._id })
        },
        edit() {
            return this.checkPermissions('UPDATE')
        },
        async editBusinessDocument() {
            this.open = true
            this.clearBusinessDocumentErrors()
            this.setBusinessDocumentModal()
        },
        closeModal() {
            this.open = false
            this.clearBusinessDocumentErrors()
            this.clearRepresentativesInput()
            this.clearBusinessDocumentModal()
        },
    },
    beforeRouteEnter(to, from, next) {
        store.dispatch('fetchBusinessDocument', { id: to.params.id, next })
    },
}
</script>
